import UA from '@ali/tbm-ua';
import { Fetcher, OneTopRequest } from '@ali/tbm-app';
import { parseQS } from '@ali/tbm-util';
import { OnetopMock } from '../../mock';
import { OnetopPrefetch } from './prefetch';
import { DowngradeService } from './downgrade';
import { getMtop } from './mtop';

/**
 * H5通用数据获取器
 */
export class DefaultFetcher implements Fetcher {
  private useDowngrade;
  private mockService;
  private prefetchService;
  private downGradeService;

  constructor() {
    const query = parseQS(location.search) || {};
    this.useDowngrade = (query.bizpass_downgrade || '').toLowerCase() === 'yes';
    this.mockService = new OnetopMock({ query });
    this.downGradeService = new DowngradeService(this.useDowngrade);

    if (UA.isPHA || (query.enable_prefetch || '').toLowerCase() === 'yes') {
      this.prefetchService = new OnetopPrefetch();
    }
  }

  getMethod(req: OneTopRequest) {
    const { downgradeOptions, prefetchKey, shouldPrefetchFn } = req || {};
    let method = getMtop();

    // mock数据
    if (this.mockService.isMockOpen(req.requestOptions.api)) {
      method = this.mockService.hookRequest(method);
    }

    // 预请求
    if (prefetchKey && this.prefetchService) {
      method = this.prefetchService.hookRequest(
        method,
        prefetchKey,
        shouldPrefetchFn
      );
    }

    // 容灾降级
    if (downgradeOptions) {
      return this.downGradeService.hookRequest(method, downgradeOptions);
    }

    return method;
  }
}
